import React from 'react';
import ReactDOM from 'react-dom/client';
import AppSecure from './AppSecure';
import './index.css';
import 'katex/dist/katex.min.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(<AppSecure />);
